import SEO from "@/components/site/SEO";
import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Terms & Conditions governing the use of the Altin Link website and the commercial brokerage and business consulting services provided by Altin Link Danışmanlık Hizmetleri Ltd. Şti."
        path="/terms"
      />
      <LegalLayout
        testid="terms-page"
        overline="Terms & Conditions"
        title="Terms &"
        accent="Conditions"
        intro="These Terms & Conditions govern your use of this website and the services provided by Altin Link Danışmanlık Hizmetleri Ltd. Şti. By accessing our website or engaging our services, you agree to these terms."
        updated="December 2025"
      >
        <LegalSection index="01" id="terms-acceptance" title="Acceptance of Terms">
          <p>
            By accessing or using this website you acknowledge that you have
            read, understood and agree to be bound by these Terms & Conditions
            and our Privacy Policy. If you do not agree, please do not use the
            website or our services.
          </p>
        </LegalSection>

        <LegalSection index="02" id="terms-services" title="Nature of Our Services">
          <p>
            Altin Link acts as an independent commercial brokerage and business
            consulting company. We facilitate introductions, negotiations and
            partnerships between businesses. We are not a party to any resulting
            commercial contract between introduced parties unless expressly
            agreed in writing.
          </p>
        </LegalSection>

        <LegalSection index="03" id="terms-engagement" title="Engagement & Fees">
          <p>
            The specific scope, deliverables and fees of any engagement are set
            out in a separate written agreement or engagement letter. Nothing on
            this website constitutes a binding offer to provide services on
            particular terms.
          </p>
        </LegalSection>

        <LegalSection index="04" id="terms-confidentiality" title="Confidentiality">
          <p>
            We treat client and counterparty information with strict
            confidentiality. Clients likewise agree to keep confidential any
            proprietary information, partner identities or commercial terms
            disclosed by us, and not to circumvent introductions made by Altin
            Link.
          </p>
        </LegalSection>

        <LegalSection index="05" id="terms-noncircumvention" title="Non-Circumvention">
          <p>
            Where Altin Link introduces a client to a counterparty, the client
            agrees not to bypass, avoid or circumvent Altin Link in order to
            deal directly or indirectly with that counterparty in a manner that
            deprives Altin Link of its agreed compensation, for the duration
            specified in the applicable engagement agreement.
          </p>
        </LegalSection>

        <LegalSection index="06" id="terms-ip" title="Intellectual Property">
          <p>
            All content on this website — including text, graphics, logos and the
            Altin Link brand — is the property of Altin Link Danışmanlık
            Hizmetleri Ltd. Şti. and is protected by applicable intellectual
            property laws. You may not reproduce or distribute it without our
            prior written consent.
          </p>
        </LegalSection>

        <LegalSection index="07" id="terms-liability" title="Disclaimer & Limitation of Liability">
          <p>
            While we exercise professional care, information on this website is
            provided for general purposes and without warranty of any kind. Altin
            Link is not liable for any commercial decisions taken in reliance on
            website content, or for the acts, omissions, solvency or performance
            of any introduced third party. To the maximum extent permitted by
            law, our liability is limited to the fees paid for the relevant
            engagement.
          </p>
        </LegalSection>

        <LegalSection index="08" id="terms-thirdparty" title="Third-Party Links">
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for the content, policies or practices of any
            third-party sites.
          </p>
        </LegalSection>

        <LegalSection index="09" id="terms-law" title="Governing Law & Jurisdiction">
          <p>
            These Terms & Conditions are governed by the laws of the Republic of
            Türkiye. Any disputes arising in connection with them shall be subject
            to the exclusive jurisdiction of the courts and enforcement offices
            of İstanbul, Türkiye.
          </p>
        </LegalSection>

        <LegalSection index="10" id="terms-changes" title="Changes & Contact">
          <p>
            We may update these Terms & Conditions from time to time. Continued
            use of the website constitutes acceptance of the revised terms. For
            questions, contact{" "}
            <a href="mailto:info@altin-link.com" className="text-altin-gold underline underline-offset-2">
              info@altin-link.com
            </a>
            .
          </p>
        </LegalSection>
      </LegalLayout>
    </>
  );
}
